import { IsBoolean } from 'class-validator';

export class UserRegistrationConfirmationDto {
  @IsBoolean()
  email!: boolean;

  @IsBoolean()
  mobileNumber!: boolean;
}
